export default {
  sm: `
  Technology that<br> 
  protects the nature,<br> 
  energy that takes<br> 
  care of people 
  `,
  md: `
  Technology that protects<br> 
  the nature, energy that<br> 
  takes care of people 
  `,
  lg: `
  Technology that protects the nature,<br>
  energy that takes care of people 
  `,
  xxl: `
  Technology that protects the nature,<br>
  energy that takes care of people 
  `,
};
